<main id="page-auth" class="page-auth">
    <section>
        <article class="auth-box">
            <h1 translate>auth.resetPassword.new</h1>
            <div class="auth-box__form">
                <div class="header">
                    <img src="/assets/images/logo-ubaristi.svg" alt="Ubaristi" title="Ubaristi" class="logo">
                    <p *ngIf="!done" class="text" translate>auth.resetPassword.completeAllFields</p>
                </div>
                <div *ngIf="(resetPassword$ | async)">
                    <app-reset-password-form *ngIf="!done"
                                             (reset)="onResetPassword($event)"
                                             [errors]="fieldErrors">
                    </app-reset-password-form>
                    <app-reset-password-done *ngIf="done"></app-reset-password-done>
                  </div>
                  <app-reset-password-invalid *ngIf="!(resetPassword$ | async)"></app-reset-password-invalid>
                </div>
        </article>
    </section>
</main>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password.component.html